import React, { Component } from "react";
import ReactTable from "react-table";

import { formatCurrency } from "../../utils/constants";

import Details from '../forms/winners/Details';

const columns = (language,game) => [
  {
    Header: "Ticket #",
    accessor: "number"
  },
  {
    Header: "Draw",
    accessor: d => d.prize > 0 ? `${d.title}: ${formatCurrency(d.prize, 2)}` : d.title,
    id: "title"
  },
  {
    Header: "Card",
    id: "card.id",
    accessor: d => d.card === null ? "" : (
      <div>
        {d.card.suit === "D" ? (<span style={{ "color": "red" }}>&diams;</span>) : ""} 
        {d.card.suit === "H" ? (<span style={{ "color": "red" }}>&hearts;</span>) : ""} 
        {d.card.suit === "S" ? (<span>&spades;</span>) : ""} 
        {d.card.suit === "C" ? (<span>&clubs;</span>) : ""} 
        {" "}
        {d.card.rank}
      </div>
    )
  },
  {
    Header: "First Name",
    accessor: "first_name"
  },
  {
    Header: "Last Name",
    accessor: "last_name"
  },
  {
    Header: "Email",
    accessor: "email"
  },
  {
    Header: "Phone",
    accessor: "phone"
  }
];

class WinnersTable extends Component {
  constructor(props) {
    super(props);
  }
  render() {
    const { language, game, winners, init, isLoading } = this.props
    return (
      <ReactTable
        data={winners}
        columns={columns(language, game)}
        className="-striped -highlight"
        manual
        pages={1} // Display the total number of pages
        loading={isLoading} // Display the loading overlay when we need it
        resizable={false}
        defaultPageSize={100}
        minRows={0}
        SubComponent={row => {
          if (row.original.number === null) return false;
          return (
            <Details winner={row.original} init={init} />
          );
        }}
      />
    );
  }
}

export default WinnersTable;
